import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-day-of-month-component',
  templateUrl: './dayOfMonth.component.html',
  styleUrls: ['/dayOfMonth.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DayOfMonthComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useValue: (c: FormControl) => {
        const err = {
          noDaySelected: {
            content: 'No day selected',
          },
        };

        return !c.value ? err : null;
      },
      multi: true,
    },
  ],
})
export class DayOfMonthComponent implements ControlValueAccessor {
  @Input() formControl: FormControl;
  daysOfMonth = [];
  public selectedDay: number;

  constructor() {
    for (let i = 1; i <= 31; i += 1) {
      this.daysOfMonth.push(i);
    }
  }

  private propagateChange = (_: any) => { };

  registerOnChange(fn: any) {
    this.propagateChange = fn;
  }

  private propagateTouch = () => { };

  registerOnTouched(fn: any) {
    this.propagateTouch = fn;
  }

  writeValue(value) {
    this.selectedDay = value;
  }

  select(day) {
    this.selectedDay = day;
    this.propagateChange(day);
  }

  onInputBlur() {
    setTimeout(
      () => {
        this.propagateTouch();
      },
      100);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/clients/views/addEditTaskView/RepeatSelectComponent/DayOfMonthComponent/dayOfMonth.component.ts